



















import { Component, Vue, Prop, Watch } from 'vue-property-decorator';
import Forms from '@/components/Forms.vue';
import { patchAdminUserTokenIp } from '@/api/api';
import UserToken from '@/models/UserToken';

@Component({
    components: {
        Forms,
    },
})
export default class UserTokenIpsAdminForm extends Vue {
    errors: any = {};
    error: string | null = null;
    type: string = 'edit';
    @Prop() userToken!: UserToken;
    loading: boolean = false;

    get title() {
        return `Modification de(s) IP(s) autorisé(s)`;
    }

    clickButton() {
        // @ts-ignore
        this.$refs.form.submit();
    }

    get items() {
        return [
            {
                label: 'IP(s) serveur autorisé(s) (A séparé par des virgules)',
                name: 'ips',
                type: 'text',
                items: this.userToken.ips,
            }
        ]
    }

    defaultValue: any | null = {
        ips: null,
    }
    values: any = this.defaultValue;

    async created(): Promise<void> {
        this.init();
    }

    async init() {
        this.loading = true;
        this.defaultValue.ips = this.userToken.ips || null;
        this.loading = false;
    }

    async submit(form: any) {
        this.loading = true;
        const $vs = (this as any).$vs;
        try {
            await patchAdminUserTokenIp(this.userToken.id, form.ips);
            $vs.notify({
                color: 'success',
                position: 'top-right',
                title: 'Modification',
                text: `Modification des Ips autorisé réussie`,
            });
        }catch (error) {
            $vs.notify({
                color: 'danger',
                position: 'top-right',
                title: 'Erreur',
                text: `La modification des Ips autorisé à échoué`,
            });
        } finally {
            this.loading = false;
        }
    }
}
